class VoteTimer extends HTMLElement {
  constructor() {
    super();

    this.days = this.querySelector('.vote__days');
    this.hours = this.querySelector('.vote__hours');
    this.mins = this.querySelector('.vote__minutes');
    this.secs = this.querySelector(".vote__seconds");

    this.tick = this.tick.bind(this)
    this.getSeconds();
  }

  getSeconds() {
    const nowDate = new Date(
      new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
    );
    const dy = 4 ; //Sunday through Saturday, 0 to 6
    const countertime = new Date(nowDate.getFullYear(),nowDate.getMonth(),nowDate.getDate(),0,0,0); //20 out of 24 hours = 8pm
    
    const curtime = nowDate.getTime(); //current time
    const atime = countertime.getTime(); //countdown time
    let diff = parseInt((atime - curtime) / 1000);
    if (diff > 0) { this.curday = dy - nowDate.getDay() }
    else { this.curday = dy - nowDate.getDay() -1 } //after countdown time
    if (this.curday < 0) { this.curday += 7; } //already after countdown time, switch to next week
    if (diff <= 0) { diff += (86400 * 7) }
    this.startTimer (diff);
  }

  startTimer(secs) {
    this.secTime = parseInt(secs);
    this.ticker = setInterval(this.tick, 1000);
    this.tick(); //initial count display
  }

  tick() {
    let secs = this.secTime;

    if (secs > 0) {
      this.secTime--;
    } else {
      clearInterval(this.ticker);
      this.getSeconds(); //start over
    }
    
    const days = Math.floor(secs/86400);
    secs %= 86400;
    const hours= Math.floor(secs/3600);
    secs %= 3600;
    const mins = Math.floor(secs/60);
    secs %= 60;
    
    //update the time display
    this.days.textContent = this.curday;
    this.hours.textContent = ((hours < 10 ) ? "0" : "" ) + hours;
    this.mins.textContent = ( (mins < 10) ? "0" : "" ) + mins;
    this.secs.textContent = ( (secs < 10) ? "0" : "" ) + secs;
  }
}

customElements.define("vote-timer", VoteTimer);

class VoteItems extends HTMLElement {
  constructor() {
    super();
    this.placeHolderItem = this.querySelector("vote-item");
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(this);

      fetch("https://6301d11c5412.ngrok.io/vote/current-items")
        .then((response) => response.json())
        .then((voteItems) => {
          const voteItemNodes = voteItems.map((voteItem) => {
            const voteItemNode = this.placeHolderItem.cloneNode(true);

            const imageElement = voteItemNode.querySelector('img');

            imageElement.srcset = voteItem.featuredImage.url;
            imageElement.src = voteItem.featuredImage.url;

            voteItemNode.querySelector(".vote__item-summary-bar__thresold").textContent = voteItem.threshold;
            voteItemNode.querySelector(
              "progress"
            ).max = voteItem.threshold;

            voteItemNode.querySelector('[name="id"]').value = voteItem.id.split("/").pop();

            return voteItemNode
          })

          this.textContent = "";
          voteItemNodes.forEach((voteItemNode) => {
            this.appendChild(voteItemNode)
          })
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("vote-items", VoteItems);

class VoteItem extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.form.querySelectorAll('[type="submit"]').forEach((submitBtn) => {
      submitBtn.addEventListener("click", this.handleButtonClick.bind(this))
    })
  }

  handleButtonClick(evt) {
    this.action = evt.currentTarget.name;
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
  }
}

customElements.define("vote-item", VoteItem);
